import { createFileRoute } from '@tanstack/react-router';
import SetupLayout from '@/layouts/SetupLayout.tsx';

export const Route = createFileRoute('/_manager/_setup')({
  component: SetupLayout,
});
